export enum MeetingSidebarTabEnum {
  details = "Details",
  topics = "Topics",
  meetings = "Meetings",
  artifacts = "Items",
  askAI = "Ask AI",
  workHistory = "Work history",
  rolesAndReviews = "Roles and Reviews",
}

export const meetingSidebarAriaLabel = "Meeting Sidebar";
